import React from 'react';
import { useMutation } from 'react-query';
import { AdminLayout } from 'src/Layouts';
import { Container, ContentGrid, ConversationsContainer } from './styles';
import { useParams, useHistory } from 'react-router-dom';
import TicketDetailsHeader from 'src/Components/Tickets/TicketDetailsHeader';
import TicketInformation from 'src/Components/Tickets/TicketInformation/TicketInformation';
import TicketRightPanel from 'src/Components/Tickets/TicketRightPanel/TicketRightPanel';
import TicketContactInfo from 'src/Components/Tickets/TicketContactInfo/TicketContactInfo';
import TicketManagementInfo from 'src/Components/Tickets/TicketManagementInfo/TicketManagementInfo';
import { useTicket } from 'src/hooks/useTicket';
import { ticketsService } from 'src/Utils/ticketsService';
import InternalConversation from 'src/Components/Tickets/InternalConversation/InternalConversation';
import ExternalConversation from 'src/Components/Tickets/ExternalConversation';
import ChangeHistory from 'src/Components/Tickets/ChangeHistory/ChangeHistory';
import { SUCCESS_MESSAGES, ERROR_MESSAGES } from 'src/Utils/toastMessages';
import { showSuccessToast, showErrorToast } from 'src/Utils/toastHelper';
var renderStateMessage = function (message) { return (React.createElement(AdminLayout, null,
    React.createElement(Container, null,
        React.createElement("div", null, message)))); };
var TicketsDetails = function () {
    var _a, _b;
    var id = useParams().id;
    var history = useHistory();
    var _c = useTicket(id ? parseInt(id) : null), ticket = _c.ticket, loading = _c.loading, error = _c.error;
    var _d = useMutation(function (notifyClient) {
        return ticketsService.completeTicket({
            id: parseInt(id),
            notify_client: notifyClient,
        });
    }, {
        onSuccess: function () {
            showSuccessToast(SUCCESS_MESSAGES.tickets.completed);
            history.goBack();
        },
        onError: function (error) {
            console.error('Error completing ticket:', error);
            showErrorToast(error, ERROR_MESSAGES.tickets.complete);
        },
    }), mutateCompleteTicket = _d[0], isCompletingTicket = _d[1].isLoading;
    var handleCompleteTicket = function (notifyClient) {
        mutateCompleteTicket(notifyClient);
    };
    var handleTicketUpdated = function () {
        history.goBack();
    };
    if (loading)
        return renderStateMessage('Loading...');
    if (error)
        return renderStateMessage("Error: " + error);
    if (!ticket)
        return renderStateMessage('Ticket not found');
    return (React.createElement(AdminLayout, null,
        React.createElement(Container, null,
            React.createElement(TicketDetailsHeader, { ticketNumber: ticket.ticket_number.toString(), status: ticket.status, building: ((_a = ticket.building) === null || _a === void 0 ? void 0 : _a.name) || '', apartment: (_b = ticket.apartment) === null || _b === void 0 ? void 0 : _b.number, date: ticket.created_at
                    ? new Date(ticket.created_at).toLocaleDateString()
                    : '', service: ticket.provider_service, showNotifyCheckbox: !ticket.internal && !ticket.external_client, onCompleteTicket: handleCompleteTicket }),
            React.createElement(ContentGrid, null,
                React.createElement(TicketInformation, { ticket: ticket, onSave: handleTicketUpdated }),
                React.createElement(TicketRightPanel, { ticket: ticket },
                    React.createElement(TicketContactInfo, { ticket: ticket }),
                    React.createElement(TicketManagementInfo, { ticket: ticket }))),
            React.createElement(ConversationsContainer, null, ticket.internal ? (React.createElement(InternalConversation, { ticket: ticket, fullWidth: true })) : (React.createElement(React.Fragment, null,
                React.createElement(ExternalConversation, { ticket: ticket }),
                React.createElement(InternalConversation, { ticket: ticket })))),
            React.createElement(ChangeHistory, { ticket: ticket }))));
};
export default TicketsDetails;
